(function () {
    "use strict";

    angular.module("app").component("cisTechnicalView", {
        templateUrl: "@/cis/cis-technical-view.template.html",
        bindings: {
            request: "<",
            installations: "<",
        },
        controller: ViewController
    });

    ViewController.$inject = ["$rootScope"];
    function ViewController($rootScope) {
        const vm = this;

        vm.PhysicalInstallationStatusCodes = $rootScope.codePhysicalInstallationStatusCodes;
    }
})();